'use client'
import React, { useState, useEffect } from 'react'
import Link from 'next/link'
import { useIsActiveLink } from '@l2p/apps-shared'

interface NavLinkProps {
  href: string
  className?: string
  activeClassName?: string
  children: React.ReactNode
  pathActive?: string
}

const NavLink: React.FC<NavLinkProps> = ({
  href = '',
  children,
  className = '',
  activeClassName,
  pathActive,
}) => {
  const [mounted, setMounted] = useState(false)
  const isActiveLink = useIsActiveLink(pathActive || href)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) return <></>
  return (
    <Link
      className={`${className} ${isActiveLink ? activeClassName : ''}`}
      href={href}
    >
      {children}
    </Link>
  )
}

export default NavLink
